var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2A39604F-984A-4C39-917D-1D2D1F1C7129") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 47.9999 0 47.9999 47.9999 0 47.9999"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Weboldal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Synflex-Swagers",
    transform: "translate(-320.000000, -1011.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(320.000000, 1011.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.969,34.462 L31.331,34.462 L31.331,27.202 C31.331,25.469 31.297,23.243 28.919,23.243 C26.503,23.243 26.134,25.129 26.134,27.076 L26.134,34.462 L21.495,34.462 L21.495,19.53 L25.948,19.53 L25.948,21.573 L26.008,21.573 C26.629,20.397 28.143,19.16 30.403,19.16 C35.102,19.16 35.969,22.251 35.969,26.272 L35.969,34.462 Z M16.26,17.492 C14.769,17.492 13.565,16.285 13.565,14.799 C13.565,13.316 14.769,12.11 16.26,12.11 C17.746,12.11 18.951,13.316 18.951,14.799 C18.951,16.285 17.746,17.492 16.26,17.492 L16.26,17.492 Z M13.935,34.462 L18.583,34.462 L18.583,19.53 L13.935,19.53 L13.935,34.462 Z M48,12.556 C48,5.65 42.35,0 35.444,0 L12.556,0 C5.65,0 0,5.65 0,12.556 L0,35.444 C0,42.35 5.65,48 12.556,48 L35.444,48 C42.35,48 48,42.35 48,35.444 L48,12.556 Z",
    id: "Fill-1",
    fill: "#363636",
    mask: "url(#mask-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a97af2132c3870457bcc177d711f5364.svg";
export { ForwardRef as ReactComponent };